import { ActionBar } from "$components/action-bar/action-bar";
import { useRegisterActionBar } from "$components/action-bar/action-bar-offset";
import { ActionBarSpacer } from "$components/action-bar/action-bar-spacer";
import type { ActionItem } from "$components/action-bar/action-item";
import { StockRequestsIcon } from "$components/icons";
import { Page } from "$components/page";
import { useUser } from "$global-providers/user-provider";
import InventoryTitleRow from "$routes/inventory/_lib/inventory-title-row";
import { LocationSelectWithAllOption } from "$routes/inventory/_lib/location-select-with-all-option";
import {
  linkToFulfillInventoryMoveRequest,
  linkToInventoryMoveRequestNew,
  linkToInventoryMoveRequestOverview,
} from "$routes/inventory/links";
import { Box, Grid } from "@material-ui/core";
import { type InventoryMoveRequestStatus, Role } from "elephant-web/gql";
import { useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import MoveRequestsTable from "./_lib/move-requests-table";
import StatusSelect from "./_lib/status-select";

export default function MoveRequests() {
  const [statusFilter, setStatusFilter] =
    useState<InventoryMoveRequestStatus | null>(null);
  const [locationId, setLocationId] = useState<string | null>(null);
  const { role: roleName } = useUser();
  const navigate = useNavigate();
  const actionBarRef = useRef<HTMLElement>(null);
  useRegisterActionBar(actionBarRef);

  function onStatusChange(status: InventoryMoveRequestStatus | null) {
    setStatusFilter(status);
  }

  const actions: ActionItem[] = [
    {
      id: "inventory.requests.button.newRequest",
      defaultMessage: "New Request",
      variant: "primary",
      icon: <StockRequestsIcon />,
      onClick: () => navigate(linkToInventoryMoveRequestNew()),
    },
  ];

  return (
    <>
      <Page data-dense>
        <InventoryTitleRow
          title={
            <FormattedMessage
              id="inventory.requests.title"
              defaultMessage="Inventory Requests"
            />
          }
        >
          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item xs={12} sm="auto">
              <Box minWidth="300px">
                <LocationSelectWithAllOption
                  value={locationId}
                  onChange={setLocationId}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm="auto">
              <Box minWidth="140px">
                <StatusSelect value={statusFilter} onChange={onStatusChange} />
              </Box>
            </Grid>
          </Grid>
        </InventoryTitleRow>
        <Box marginTop={4}>
          <MoveRequestsTable
            status={statusFilter}
            receivingLocationId={locationId}
            onRowClick={({ id, status: rowStatus }) => {
              navigate(
                rowStatus === "PENDING" && roleName === Role.Pharmacist
                  ? linkToFulfillInventoryMoveRequest(id)
                  : linkToInventoryMoveRequestOverview(id),
              );
            }}
          />
        </Box>
        <ActionBarSpacer />
      </Page>
      <ActionBar actions={actions} containerRef={actionBarRef} />
    </>
  );
}
